export default __webpack_public_path__ + "static/media/Ali.dd74c6de.mp4";